export default __webpack_public_path__ + "d1615fb9cd7f67f5018cebce5b5b2114.woff2";